export const OTHER_BUSINESS_TYPE = 'Other';

export const BUSINESS_TYPES = [
  'Salon',
  'Spa & Wellness',
  'Fitness Studio',
  'Home & Field Services',
  'Automotive',
  'Medical / Healthcare',
  'Professional Services',
  OTHER_BUSINESS_TYPE,
];

export const COUNTRIES = [
  'United States',
  'Canada',
  'United Kingdom',
  'Australia',
  'Afghanistan',
  'Albania',
  'Algeria',
  'Argentina',
  'Austria',
  'Belgium',
  'Brazil',
  'Chile',
  'China',
  'Colombia',
  'Costa Rica',
  'Croatia',
  'Czech Republic',
  'Denmark',
  'Egypt',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hong Kong',
  'India',
  'Indonesia',
  'Ireland',
  'Israel',
  'Italy',
  'Japan',
  'Kenya',
  'Malaysia',
  'Mexico',
  'Netherlands',
  'New Zealand',
  'Nigeria',
  'Norway',
  'Pakistan',
  'Philippines',
  'Poland',
  'Portugal',
  'Romania',
  'Saudi Arabia',
  'Singapore',
  'South Africa',
  'South Korea',
  'Spain',
  'Sweden',
  'Switzerland',
  'Taiwan',
  'Thailand',
  'Turkey',
  'Ukraine',
  'United Arab Emirates',
  'Vietnam',
];
